import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';

import { IconNames } from '../../shared';
import { ButtonComponent } from '../buttons/button/button.component';
import { SvgIconComponent } from '../icons/svg-icon/svg-icon.component';

@Component({
    selector: 'lib-heading-with-button',
    standalone: true,
    imports: [CommonModule, ButtonComponent, SvgIconComponent],
    templateUrl: './heading-with-button.component.html',
    styleUrl: './heading-with-button.component.css'
})
export class HeadingWithButtonComponent {
    /* eslint-disable */
    @Input() heading: string = '';
    @Input() buttonText: string = '';
    @Input() iconName: IconNames | undefined = undefined;
    @Input() headingNoMargin: boolean = false;
    @Input() disabled: boolean = false;

    @Output() onClick = new EventEmitter();
}
